/* eslint-disable radix */
/* eslint-disable no-plusplus */
import React from 'react';
import { notification } from 'antd';
import moment from 'moment';
import localization from 'moment/locale/pt-br';
import CNPJ from './cnpj';

export const isNullOrUndefined = value => value == null;

export const normalizarCnpj = valor => {
  if (!valor) return valor;

  return String(valor)
    .toUpperCase()
    .replace(/[^0-9A-Z]+/g, '')
    .slice(0, 14);
};

export const validarCnpj = valor => {
  if (!valor) return;
  const cnpj = normalizarCnpj(valor);

  if (cnpj === '') return false;

  if (cnpj.length !== 14) {
    return false;
  }

  try {
    return CNPJ.isValid(cnpj);
  } catch (error) {
    return false;
  }
};

export const validarCpf = valor => {
  if (!valor) return;
  const cpf = valor.replace(/[^\d]+/g, '');
  if (cpf === '') return false;
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false;
  }
  // Valida 1o digito
  let add = 0;
  for (let i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(9))) {
    return false;
  }
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i);
  }
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(10))) {
    return false;
  }
  return true;
};

export const somenteNumeros = valor => {
  if (!valor) {
    return valor;
  }

  return String(valor).replace(/[^\d]+/gim, '');
};
export const normalizarString = valor => {
  if (!valor) {
    return valor;
  }
  return valor.toUpperCase().trim();
};

export const removerCaracteresEspeciais = valor => {
  if (!valor) {
    return valor;
  }
  return valor.replace(/[^\w\s]/gi, '');
};

export const removerLetras = valor => {
  if (!valor) {
    return valor;
  }
  return valor.replace(/[a-zA-Z]/gi, '');
};

export const formatarTelefone = valor => {
  if (!valor) return;
  let novoValor = valor.slice(0, 10);
  novoValor = novoValor.replace(/\D/g, '');
  // novoValor = novoValor.replace(/(\d)(\d{4})$/, '$1-$2');

  return novoValor;
};

export const formatarCelular = valor => {
  if (!valor) return;
  const valorFormatado = valor.replaceAll(
    // eslint-disable-next-line no-useless-escape
    /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
    ''
  );
  return valorFormatado.replaceAll(' ', '');
};

export const mascaraCelular = (ddd, numero) => {
  if (!ddd) return;
  if (!numero) return;

  let numeroFormatado = '';

  const novoDDD = ddd.replace(/([^\d])+/gim, '');
  let novoNumero = numero.replace(/([^\d])+/gim, '');

  if (novoDDD.length === 3) {
    numeroFormatado += `(${novoDDD.substr(1)}) `;
  } else if (novoDDD.length !== 2) {
    return null;
  } else {
    numeroFormatado += `(${novoDDD}) `;
  }

  if (novoNumero.length === 9) {
    novoNumero = `${novoNumero.substr(0, 5)}-${novoNumero.substr(-4)}`;
  } else {
    novoNumero = `${novoNumero.substr(0, 4)}-${novoNumero.substr(-4)}`;
  }

  numeroFormatado += novoNumero;

  return numeroFormatado;
};

export const mascaraCelularInteiro = numero => {
  if (!numero) return null;

  const numeros = somenteNumeros(numero);

  if (numeros.length < 11) return numero;
  const ddd = numeros.substring(0, 2);
  const numeroNovo = numeros.substring(2);

  return mascaraCelular(ddd, numeroNovo);
};

export const formatarCpf = valor => {
  if (!valor) return;

  const novoValor = valor.replace(
    /(\d{3})(\d{3})(\d{3})(\d{2})/,
    '$1.$2.$3-$4'
  );

  return novoValor;
};

export const formatarCnpj = valor => {
  if (!valor) return;

  const novoValor = normalizarCnpj(valor);

  if (novoValor.length === 11) {
    return novoValor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }

  if (novoValor.length <= 2) return novoValor;
  if (novoValor.length <= 5) return `${novoValor.slice(0, 2)}.${novoValor.slice(2)}`;
  if (novoValor.length <= 8) {
    return `${novoValor.slice(0, 2)}.${novoValor.slice(2, 5)}.${novoValor.slice(5)}`;
  }
  if (novoValor.length <= 12) {
    return `${novoValor.slice(0, 2)}.${novoValor.slice(2, 5)}.${novoValor.slice(
      5,
      8
    )}/${novoValor.slice(8)}`;
  }

  return `${novoValor.slice(0, 2)}.${novoValor.slice(2, 5)}.${novoValor.slice(
    5,
    8
  )}/${novoValor.slice(8, 12)}-${novoValor.slice(12)}`;
};

export const formatarDinheiro = valor => {
  if (valor || valor === 0) {
    const novoValor = Number(valor).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    return novoValor;
  }
};

export const formatarDataEmTexto = valor => {
  if (!valor) return;

  moment.updateLocale('pt-br', localization);
  const novoValor = moment(valor).calendar();

  return novoValor;
};

export const formatarData = (valor, format = 'DD/MM/YYYY HH:mm') => {
  if (!valor) return;

  const novoValor = moment(valor).format(format);

  return novoValor;
};

export const formatarCpfCnpj = valor => {
  if (!valor) return;

  const novoValor = normalizarCnpj(valor);

  if (novoValor.length === 11) {
    return novoValor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }
  if (novoValor.length === 14) {
    return formatarCnpj(novoValor);
  }

  return novoValor;
};

export const beforeUpload = file => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    notification.error({
      message: 'Algo deu errado',
      description: 'Por favor insira um arquivo válido em formato de imagem',
    });
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    notification.error({
      message: 'Algo deu errado',
      description: 'Arquivo maior que 2MB',
    });
  }
  return isJpgOrPng && isLt2M;
};

export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const capitalize = s => {
  if (!s) return;
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const formatarCEP = cep => {
  if (!cep || typeof cep !== 'string') return;
  return cep.replace(/\D/g, '');
};

export const mascaraCEP = cep => {
  const newCep = formatarCEP(cep);
  // return newCep && `${newCep.substr(0, 5)}-${newCep.substr(5, newCep.length - 5)}`;
  return newCep;
};

export const diferencaEmHoras = (data1, data2) => {
  const duration = moment.duration(moment(data1).diff(data2));
  const hours = Math.trunc(duration.asHours());

  const minutes = Math.round(duration.asMinutes());
  const seconds = moment.unix(duration.asSeconds()).format('ss');

  return `${hours < 10 ? `0${hours}` : hours}:${
    minutes < 10 ? `0${minutes}` : minutes
  }:${seconds}`;
};

export const getDescriptionError = (err, jsx) => {
  if (!err) return;

  let mensages = '';
  const render = [];

  if (Array.isArray(err?.response?.data?.validation)) {
    err.response.data.validation.forEach(item => {
      if (jsx) {
        render.push(
          <>
            {` - ${item}`}
            <br />
          </>
        );
      } else {
        mensages += ` - ${item}`;
      }
    });
  } else if (jsx) {
    render.push(err?.response?.data?.message);
  } else {
    mensages = err?.response?.data?.message;
  }

  return jsx ? render : mensages;
};

export const normalizeParams = params =>
  JSON.parse(
    JSON.stringify(params, (_, value) => {
      let val = value || undefined;
      if (Array.isArray(val) && value.length === 0) {
        val = undefined;
      }
      return typeof val === 'string' ? val.trim() : val;
    })
  );

export const convertToIsoString = data => {
  if (!data) {
    return;
  }
  return moment(data).format();
};

export const formatString = (item = '') =>
  item
    .toLowerCase()
    .replace(/[àáâãäå]/, 'a')
    .replace(/[èéêë]/, 'e')
    .replace(/[ìíîï]/, 'i')
    .replace(/[òóôõö]/, 'o')
    .replace(/[ùúûü]/, 'u')
    .replace(/[ç]/, 'c')
    .replace(/[^a-z0-9]/gi, '');

export const redirectUrlInRoles = role => {
  const obj = {
    CadastroMatriz: '/cadastro',
    MenuRelatorio: '/relatorios',
    CadastroUsuario: '/cadastro',
    CadastroCliente: '/cadastro',
    CadastroConsulta: '/cadastro',
    Operador: '/painel-de-controle',
    CadastroGrupoUsuario: '/cadastro',
    ControleWebhook: '/gestao/erros-webhook',
    MenuPainelControle: '/painel-de-controle',
    ControleParametrosGerais: '/parametros-gr',
    PortalInformacoes: '/portal-de-informacoes',
    OperadorExterno: '/consultas-externas-painel',
    MenuConsultasExternas: '/consultas-externas-painel',
    MenuAtendimentoExterno: '/atendimento-externo',
    VisualizarLogsIntegracao: '/gestao/logs-integracao',
    VisualizarLogsCadastros: '/gestao/logs-cadastros',
  };
  return obj[role];
};

export const toDate = dateStr => {
  if (dateStr && dateStr.includes('/')) {
    const parts = dateStr.split('/');
    return new Date(parts[2], parts[1] - 1, parts[0]);
  }
  return dateStr;
};

export const titleCase = string =>
  string[0].toUpperCase() + string.slice(1).toLowerCase();

export const setMaskTelefone = string => {
  if (isNullOrUndefined(string)) return string;

  return string
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1)$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
    .replace(/(-\d{4})\d+?$/, '$1');
};

export const setMaskData = string => {
  const dataFormatada = string
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d{2})$/, '$1$2')
    .slice(0, 10);

  if (
    dataFormatada.length === 10 &&
    !moment(dataFormatada, 'DD/MM/YYYY', true).isValid()
  ) {
    return 'Data inválida';
  }

  return dataFormatada;
};

export const anonimizarNome = nome => {
  const palavras = nome.split(' ');
  const primeiroNome = palavras[0];
  const sobrenomes = palavras.slice(1);

  let resultado = primeiroNome;

  for (let i = 0; i < sobrenomes.length; i++) {
    resultado += ' ';
    for (let j = 0; j < sobrenomes[i].length; j++) {
      resultado += '*';
    }
  }

  return resultado;
};

export const anonimizarCpf = cpf => {
  const primeirosDigitos = cpf.substring(0, 3);
  const ultimosDigitos = cpf.substring(cpf.length - 2);
  const cpfAsteriscos = cpf.replace(/\d/g, '*');
  return (
    primeirosDigitos +
    cpfAsteriscos.substring(3, cpfAsteriscos.length - 2) +
    ultimosDigitos
  );
};
